import {
  CLUB_MEMBERSHIP_PRODUCT_HANDLE,
  DIAMOND_PRODUCT_HANDLE,
  KIT_PRODUCT_HANDLE,
  PREMIUM_PROCESSING_FEE_PRODUCT_HANDLE,
} from '@shared/lib/constants';
import { getProduct } from '@shared/lib/shopify';
import { Product, ProductVariant } from '@shared/lib/shopify/types';
import { assertPresent } from '@shared/lib/utils';

export async function getBaseDiamondProduct(): Promise<Product> {
  return assertPresent(await getProduct(DIAMOND_PRODUCT_HANDLE));
}

export async function getClubMembershipProduct(): Promise<Product> {
  return assertPresent(await getProduct(CLUB_MEMBERSHIP_PRODUCT_HANDLE));
}

export async function getClubPlatinumVariant(): Promise<ProductVariant> {
  return assertPresent(
    (await getClubMembershipProduct()).variants.find((variant) => variant.title === 'Platinum')
  );
}

export async function getClubGoldVariant(): Promise<ProductVariant> {
  return assertPresent(
    (await getClubMembershipProduct()).variants.find((variant) => variant.title === 'Gold')
  );
}

export async function getProcessingFeeProduct(): Promise<Product> {
  return assertPresent(await getProduct(PREMIUM_PROCESSING_FEE_PRODUCT_HANDLE));
}

export async function getPremiumProcessingVariant(): Promise<ProductVariant> {
  return assertPresent(
    (await getProcessingFeeProduct()).variants.find(
      (variant) => parseFloat(variant.price.amount) > 0
    )
  );
}

export async function getPremiumProcessingFee(): Promise<number> {
  return parseFloat((await getPremiumProcessingVariant()).price.amount);
}

export async function getKitProduct(): Promise<Product> {
  return assertPresent(await getProduct(KIT_PRODUCT_HANDLE));
}

export async function getKitVariant(): Promise<ProductVariant> {
  return assertPresent(
    (await getKitProduct()).variants.find((variant) => parseFloat(variant.price.amount) > 0)
  );
}

export async function getKitFee(): Promise<number> {
  return parseFloat((await getKitVariant()).price.amount);
}
